import React from "react";
import LabelValue from "../../../shared/custom/labelValue/LabelValue";
import {useLanguageForShared} from "../../../shared/utils/languages/useLanguageForShared";
import {useDateCustom} from "../../../shared/custom_use/useDateCustom";
import {isArray} from "../../../shared/utils/arrayUtils";

type PrescriptionType = "LOX" | "TOC" | "POC" | "COX";

type Props = {
    data: any;
    types: PrescriptionType[]; // <-- SOLO QUI multipli
};

export function PrescriptionFlowRow({
                                        data,
                                        type,
                                    }: {
    data: any;
    type: PrescriptionType;
}) {
    const {t} = useLanguageForShared();

    const hasLevel =
        data[`level_rest_${type}`] ||
        data[`level_underStress_${type}`] ||
        data[`level_night_${type}`];

    const prefix = hasLevel ? "level" : "flow";

    return <>
        <div className="mb-3">
            <p className="title-paragraph">
                {t(`prescription.template.prescription${type}`)}
            </p>

            {/* ================= ROW 2 — MODEL ================= */}
            <div className="col-12">
                <LabelValue
                    label={t("prescription.template.model_prod")}
                    value={data[`model_prod_${type}`] || "-"}
                />
            </div>

            {data[`${prefix}_rest_${type}`] && (
                <>
                    <LabelValue
                        label={t(`prescription.template.${prefix}Rest`)}
                        value={data[`${prefix}_rest_${type}`] || "-"}
                    />
                    <LabelValue
                        label={t("prescription.template.hourDie")}
                        value={data[`${prefix}_restHourDie_${type}`] || "-"}
                    />
                </>
            )}

            {data[`${prefix}_underStress_${type}`] && (
                <>
                    <LabelValue
                        label={t(`prescription.template.${prefix}UnderStress`)}
                        value={data[`${prefix}_underStress_${type}`] || "-"}
                    />
                    <LabelValue
                        label={t("prescription.template.hourDie")}
                        value={data[`${prefix}_underStressHourDie_${type}`] || "-"}
                    />
                </>
            )}

            {data[`${prefix}_night_${type}`] && (
                <>
                    <LabelValue
                        label={t(`prescription.template.${prefix}Night`)}
                        value={data[`${prefix}_night_${type}`] || "-"}
                    />
                    <LabelValue
                        label={t("prescription.template.hourDie")}
                        value={data[`${prefix}_nightHourDie_${type}`] || "-"}
                    />
                </>
            )}

            {/* STROLLER (solo LOX) */}
            {type === "LOX" && data?.stroller !== undefined && (
                <LabelValue
                    label={t("prescription.template.stroller")}
                    value={data.stroller ? t("common.yes") : t("common.no")}
                />
            )}

            {/* TYPE FLOW (TOC / POC) */}
            {data[`pulsedFlow_${type}`] && (
                <LabelValue
                    label={t("prescription.template.typeFlow.label")}
                    value={t(
                        `prescription.template.${data[`pulsedFlow_${type}`]}Flow.label`
                    )}
                />
            )}
        </div>
    </>;

}
